<div class="fluid-container text-start my-5 py-5 testimonials-container">
    <div class="container py-0 py-md-4">
        <div class="row">
            <div class="col-12 col-md-5 mb-3 mb-md-0">
                <img
                    class="img-fluid rounded img-testimonials"
                    [attr.src]="'testimonials-img' | cmsImageSrc | async"
                    [attr.alt]="'testimonials-img' | cmsImageAlt | async"
                />
            </div>
            <div class="col-12 col-md-7">
                <h3 class="text-left mb-4">
                    {{ 'testimonials-title' | cmsText | async }}
                </h3>
                <ng-container *ngFor="let i of [1, 2]">
                    <div class="mb-md-0">
                        <div class="card h-100 my-3 text-left border-0">
                            <div class="card-body">
                                <h4
                                    class="mb-3"
                                    [innerHTML]="
                                        'testimonials-catchphrase-' + i
                                            | cmsText
                                            | async
                                    "
                                ></h4>
                                <p
                                    [innerHTML]="
                                        'testimonials-text-' + i
                                            | cmsText
                                            | async
                                    "
                                ></p>
                                <span
                                    class="d-block"
                                    [innerHTML]="
                                        'testimonials-name-' + i
                                            | cmsText
                                            | async
                                    "
                                ></span>
                                <span
                                    class="text-muted d-block"
                                    [innerHTML]="
                                        'testimonials-location-' + i
                                            | cmsText
                                            | async
                                    "
                                ></span>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div>
                    <button
                        *ngIf="$readMoreBtnUrl | async as url"
                        class="btn btn-primary btn-muted-grey"
                        [routerLink]="url"
                    >
                        <app-content
                            key="testimonials-read-more-button-text"
                            id="testimonials-read-more-button"
                        ></app-content>
                        <i class="fa fa-chevron-right ms-2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
